function StaffData(state = { agentList: [], relatedStaffs: [], middlemanList:[] }, action) {

  switch (action.type) {

    case "GET_AGENT_LIST":
      return {
        ...state,
        agentList: action.data
      };
    case "GET_RELATEDSTAFFS":
      return {
        ...state,
        agentList: action.data
      };
      case "GET_MIDDLEMAN_LIST":
        return{
          ...state,
          middlemanList: action.data
        };
        case "GET_STAFF_ATTACHMENTS":
            return {
                ...state,
                attachmentList: action.data
            }
        case "STAFF_SEARCH_FILTERS":
            return {
                ...state,
                staffSearchFilters: action.data
            }
        case "SEARCH_STAFF":
            return {
                ...state,
                searchStaffList: action.data
            }        
    default:
      return state;
  }
}
export default StaffData;